import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "youtubeId", "allow"]

  declare readonly titleTarget: HTMLInputElement
  declare readonly youtubeIdTarget: HTMLInputElement
  declare readonly allowTarget: HTMLInputElement

  paste(event: ClipboardEvent) {
    const pasteData = event.clipboardData?.getData('text/plain')
    if (!pasteData) return

    if (pasteData.includes('<iframe')) {
      event.preventDefault()
      this.parseIframe(pasteData)
    }
  }

  private parseIframe(html: string) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const iframe = doc.querySelector('iframe')

    if (!iframe) return

    // Extract youtube_id from src
    const src = iframe.getAttribute('src') || ''
    const youtubeIdMatch = src.match(/\/embed\/([^/?]+)/)
    if (youtubeIdMatch && youtubeIdMatch[1]) {
      this.youtubeIdTarget.value = youtubeIdMatch[1]
    }

    // Extract title
    const title = iframe.getAttribute('title')
    if (title) {
      this.titleTarget.value = title
    }

    // Extract allow
    const allow = iframe.getAttribute('allow')
    if (allow) {
      this.allowTarget.value = allow
    }
  }
}
